import { makeStyles } from '@material-ui/core/styles';
import { colors } from 'styles/colors';
import fonts from 'styles/fonts';
import spacing from 'styles/spacing';

const useStyles = makeStyles({
  noDataComponent: {
    padding: '48px 0',
    maxHeight: '64px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    borderTop: `1px solid ${colors.lightGray}`,
    borderBottom: `1px solid ${colors.lightGray}`,

    '& > span': {
      fontSize: fonts.sizes.small,
      color: colors.black,
      fontWeight: fonts.weights.normal,
      letterSpacing: '0.01px',
      lineHeight: '20px',
    },
  },
  loadingDataComponent: {
    padding: '48px 0',
    height: '64px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  rightComponentsContainer: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',

    '& > * + *': {
      marginLeft: `${spacing.xsmall}`,
    },
  },
  totalInfoContainer: {
    color: colors.black,
    fontWeight: fonts.weights.bold,
  },
});

export default useStyles;
